require("@rails/ujs").start();

import '../javascripts/home';
import '../stylesheets/base';

//require("turbolinks").start()
//require("@rails/activestorage").start()
